"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3H2v18h20V3zm-7.8415 8.0576c.36-.352.54-.824.54-1.416 0-.648-.26-1.148-.78-1.5-.512-.36-1.208-.54-2.088-.54-.624 0-1.164.08-1.62.24-.448.16-.84.36-1.176.6l.84 1.248c.208-.136.46-.272.756-.408.304-.144.66-.216 1.068-.216.44 0 .752.088.936.264.192.168.288.404.288.708 0 .224-.052.424-.156.6-.096.168-.284.304-.564.408-.272.096-.672.144-1.2.144h-.66v1.392h.648c.536 0 .952.044 1.248.132.304.08.516.204.636.372.12.16.18.36.18.6 0 .408-.132.724-.396.948-.256.224-.708.336-1.356.336-.344 0-.72-.048-1.128-.144-.4-.096-.784-.236-1.152-.42v1.536c.72.312 1.544.468 2.472.468.8 0 1.452-.112 1.956-.336.512-.232.888-.544 1.128-.936.248-.392.372-.84.372-1.344 0-.568-.18-1.02-.54-1.356-.352-.336-.872-.544-1.56-.624v-.036c.52-.128.956-.368 1.308-.72z"
  })];
};

exports.default = _default;